import { arMA } from "../../../../date-fns/locale/ar-MA.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    arMA
  }
};